import { ActionTypes } from '../../actions/index';
import { openApplyPromoCodeConfirmModal } from '../../cart/actions/cart-actions';
import { ItemType } from '../../classes/item-type';
import { deleteSeatRequest } from '../../helpers/local-storage-helpers';
import { getParameterByName, removeParameterByName } from '../../helpers/query-string-helpers';
import { IAppState } from '../../reducers/index';
import { fetchSeatMap } from '../../seatmap/actions/seatmap-fetch';

enum PromoFailure {
    PROMO_CONFLICT,
    PROMO_FAILURE
}
export function _applyPromoCode(promoCode: string) {
    return {
        type: ActionTypes.APPLY_PROMO,
        value: promoCode
    }
}

export function loadPromoCode(promoCode) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.LOAD_PROMO, value: promoCode });
    };
}


export function errorPromoApply(message: string) {
    return {
        type: ActionTypes.PROMO_ERROR,
        value: message
    }
}

function errorPromoConflict(message: string) {
    return {
        type: ActionTypes.PROMO_CONFLICT,
        value: message
    }
}

export function cancelPromoApply() {
    return {
        type: ActionTypes.CANCEL_PROMO,
    }
}

function _removePromoCode() {
    return {
        type: ActionTypes.REMOVE_PROMO,
    }
}

function emptiedCart() {
    return {
        type: ActionTypes.EMPTIED_CART,
    }
}

export function emptyCart(promoCode: string, culture: string) {
    return (dispatch, state) => {
        sendEmptyAndApplyRequest(promoCode, culture).then((response: any) => {
            handlePromoApplicationResult(response, dispatch, state, true);
        });
    }
}

function sendEmptyAndApplyRequest(promoCode: string, culture: string) {
    return fetch(`${window.location.origin}/api/seating/EmptyCartAndApply?promoCode=${promoCode}&culture=${culture}`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}

function sendApplyPromoRequest(promoCode: string, culture: string, itemNumber: number, itemType: ItemType) {
    var request = `${window.location.origin}/api/seating/ApplyPromoCode?promoCode=${encodeURIComponent(promoCode)}&culture=${encodeURIComponent(culture)}&itemNumber=${itemNumber}&itemType=${itemType}`;
    if (promoCode.length === 0) {
        request = `${window.location.origin}/api/seating/RemovePromoCode?culture=${culture}&itemNumber=${itemNumber}&itemType=${itemType}`;
    }
    return fetch(request,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}

// don't need itemNumber, itemType, and selectedPriceTypes unless for seat map apply promos
export function applyPromoCode(promoCode: string, culture: string, confirm: boolean, itemNumber: number = null, itemType: ItemType = null) {
    return (dispatch, state) => {
        const currState = (state() as IAppState);
        if (!confirm && (currState.cartModel.seats.length > 0
            // are there seats on another level. If there are we will reload this level 
            // and won't be able to match zones so those seats will be removed
            || currState.cartModel.seats.filter(cS =>
                currState.seatMapModel.allSeatPricing.map(pr => pr.zoneId)
                    .indexOf(cS.selectedPricing.zoneId) < 0).length > 0
        )) {
            dispatch(openApplyPromoCodeConfirmModal(promoCode));
        } else {            
            sendApplyPromoRequest(promoCode, culture, itemNumber, itemType).then((response: any) => {

                if (response.success) {
                    dispatch(_applyPromoCode(promoCode));
                }

                handlePromoApplicationResult(response, dispatch, state, promoCode.length > 0 ? false : true);
            });
        }
    }
}

// don't need itemNumber, itemType, and selectedPriceTypes unless for seat map apply promos
export function removePromoCode(culture: string, confirm: boolean, itemNumber: number = null, itemType: ItemType = null) {
    return (dispatch, state) => {
        if (!confirm && (state() as IAppState).cartModel.seats.length > 0) {
            dispatch(openApplyPromoCodeConfirmModal(""));
        } else {
            sendApplyPromoRequest("", culture, itemNumber ?? 0, itemType ?? 0).then((response: any) => {

                if (response.success) {
                    dispatch(_removePromoCode());
                }

                handlePromoApplicationResult(response, dispatch, state, true);
            });
        }
    }
}

function handlePromoApplicationResult(response, dispatch, state, remove: boolean) {
    if (response.success) {
        const currState = (state() as IAppState);
        const appSettings = currState.appSettingsModel;
        deleteSeatRequest(appSettings.itemId, appSettings.itemType);

        if (currState.seatMapModel.seatmapId != null && currState.cartModel.seats.length > 0) {
            dispatch(fetchSeatMap(currState.seatMapModel.seatmapId, currState.cartModel.seats, true, response.promoPriceTypeMapping));
        } else {
            if (remove && (getParameterByName('promo') != null && getParameterByName('promo').length > 0)) {
                const updatedUrl = removeParameterByName('promo');
                window.location.href = updatedUrl;
            } else {
                window.location.reload();
            }
        }
    }
    else if (!response.success && response.promoFailure === PromoFailure.PROMO_FAILURE) {
        dispatch(errorPromoApply(response.errorMessage));
    } else if (response.promoFailure === PromoFailure.PROMO_CONFLICT) {
        dispatch(errorPromoConflict(response.errorMessage));
    }

}
